import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Article from '@/pages/article/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/usfans-spreadsheet-guide',
    element: <Article />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;